import React, { Fragment, ReactElement } from 'react';
import { AlertBox, Typography } from '@vp/swan';
import { ValidatorType } from '@vp/upload-and-print-validator';
import { useValidationContext } from 'src/hooks/ValidationContextHooks';
import { text } from 'src/utils/localizationUtil';

interface Props {
  isMobile?: boolean;
}

export const PageSizeWarningCallout = ({ isMobile }: Props): ReactElement => {
  const { showPageSizeWarningCallout, validations } = useValidationContext();

  const pageSizeValidation = validations?.find(validation => validation.id === ValidatorType.PageSizeValidator);

  if (!showPageSizeWarningCallout || !pageSizeValidation) {
    return <Fragment />;
  }

  const pageSizeToken = pageSizeValidation.tokenValues?.attributeValue;

  return (
    <AlertBox
      skin="info"
      marginTop={isMobile ? 8 : 'between-subsections'}
      marginBottom={isMobile ? 8 : 'between-subsections'}
    >
      <Typography>{text('pagesize-warning-announcement', { pageSize: pageSizeToken })}</Typography>
    </AlertBox>
  );
};
